'use client';
import React, { useEffect, useState } from 'react';

import Loading from '@/components/design/loading';
import useProfile from '@/hooks/queries/useProfile';

type Props = {
  children: React.ReactNode;
};

const ProfileProvider: React.FC<Props> = ({ children }) => {
  const { data: profile } = useProfile();
  const [isLiaWebView] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return localStorage.getItem('lia_is_webview') === 'true';
  });
  const [showContent, setShowContent] = useState(isLiaWebView);

  useEffect(() => {
    let timeOut: ReturnType<typeof setTimeout> | undefined;
    if (!isLiaWebView) {
      timeOut = setTimeout(() => setShowContent(true), 5000);
    }

    return () => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
    };
  }, [isLiaWebView]);

  if (!showContent || !profile) {
    return (
      <Loading
        key={isLiaWebView === false ? 'intro' : 'spinner'}
        spinnerOnly={isLiaWebView !== false}
      />
    );
  }

  return <>{children}</>;
};

export default ProfileProvider;
